import ContactSearchStrategy from './contact-search-strategy';
import PageSearchStrategy from './page-search-strategy';

function getSearchStrategyForPath(pathname) {

  if (pathname.indexOf('/contacts') !== -1) {
    return new ContactSearchStrategy();
  }

  if (pathname.indexOf('/pages') !== -1) {
    return new PageSearchStrategy();
  }

  return null;

}

export {
  ContactSearchStrategy,
  PageSearchStrategy,
  getSearchStrategyForPath
};
